// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","197":"75fc9c18","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"c80a751156808b3e05cc","197":"69a37dbc878fb5ae61a9","293":"ae75712825189b3e4fea"}[chunkId] + ".js";
};